import {sendGetRequest, sendPostRequest, sendPutRequest} from '../requests';
import {CreatePatientProps} from '../../constants/types';

const baseUrl = '/patients';

export const addPatient = (data: CreatePatientProps) =>
  sendPostRequest(baseUrl, data);

export const updatePatientById = (entity: string, body) =>
  sendPutRequest(`${baseUrl}/${entity}`, body);

export const getAllPatients = (params: object) =>
  sendGetRequest(baseUrl, params);
